export var pageContainerStyle = {
    margin: "0 auto",
    maxWidth: 1440,
    padding: "24px 16px 48px",
};
export var authRootStyle = {
    background: "#F5F7FA",
    minHeight: "100vh",
};
export var authContainerStyle = {
    margin: "0 auto",
    maxWidth: 720,
    padding: "32px 16px 48px",
};
export var contentOnlyRootStyle = {
    minHeight: "100vh",
};
export var getContentShellStyle = function (isDesktop) { return ({
    display: "grid",
    gap: 24,
    gridTemplateColumns: isDesktop ? "280px minmax(0, 1fr)" : "1fr",
}); };
export var pageContentStyle = {
    minWidth: 0,
};
export var publicShellStyle = {
    background: "#F8FAFC",
    minHeight: "100vh",
};
